import { FC, useEffect, useState } from "react";
import { RoutesMap } from "../../../types";
import { usePatentStore } from "../../../hooks/usePatentStore";
import { patent } from "../../../types/slices/patentType";
import CustomTable from "../../../components/common/CustomTable/CustomTable";
import { ApiStatus } from "../../../types/api/status";
import { ModalConfirm } from "../../../components/common/ModalConfirm/ModalConfirm";
import { PatentFormDrawer } from "../PatentFormDrawer/PatentFormDrawer";

const columns = [
    { type: 'options', field: 'options', label: 'Acciones', align: 'center' },
    { type: 'text', field: 'name', label: 'Patente', align: 'center' },
]

const breadcrumbs = [
    { id: 1, label: 'Maestros' },
    { id: 2, label: 'Patentes', pathname: RoutesMap.PATENT_LIST }
]

export const PatentList: FC = () => {
    const { status, patents, totalRows, patentSelected,
        getPatents, setSelectedPatent, deletePatent } = usePatentStore()

    const [search, setSearch] = useState<string>('')
    const [page, setPage] = useState<number>(1)
    const [perPage, setPerPage] = useState<number>(10)

    const [showModalConfirm, setShowModalConfirm] = useState<boolean>(false)
    const [showForm, setShowForm] = useState<boolean>(false)

    useEffect(() => {
        if (search === '') {
            getDataAPI()
        } else {
            const timer = setTimeout(() => getDataAPI(), 500)
            return () => clearTimeout(timer)
        }
    }, [page, perPage, search])

    const getDataAPI = async (): Promise<void> => {
        await getPatents('', {
            page: page,
            perPage: perPage,
            search: search !== '' ? search : undefined
        })
    }

    const onSearch = (value: string): void => {
        setSearch(value)
        setPage(1)
    }

    const handleChangePage = (event: any, newPage: any) => {
        setPage(newPage + 1)
    }

    const handleChangeRowsPerPage = (event) => {
        setPerPage(+event.target.value)
        setPage(1)
    }

    const onAdd = (): void => {
        setSelectedPatent({} as patent)
        setShowForm(true)
    }

    const onEdit = (rowSelected: patent): void => {
        setSelectedPatent(rowSelected)
        setShowForm(true)
    }

    const onDelete = (rowSelected) => {
        setSelectedPatent(rowSelected)
        setShowModalConfirm(true)
    }

    const onDeleteConfirm = async (): Promise<void> => {
        const resp = await deletePatent(patentSelected?.id)
        if (resp === true) {
            setShowModalConfirm(false)
            getDataAPI()
        }
    }

    return (<>
        <CustomTable
            title="Lista de patentes"
            breadcrumbs={breadcrumbs}
            columns={columns}
            loading={status === ApiStatus.FETCHING}
            rows={patents || []}
            onRowClick={() => { }}
            hasOptions
            dense
            onSearch={onSearch}
            onAddFn={onAdd}
            onEdit={onEdit}
            onDelete={onDelete}

            totalRows={totalRows}
            rowsPerPage={perPage}
            page={page}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            withCustomPagination={true}
        />
        {showForm && (
            <PatentFormDrawer
                open={showForm}
                onClose={() => setShowForm(false)}
                onList={getDataAPI}
            />
        )}
        {showModalConfirm && (
            <ModalConfirm
                open={showModalConfirm}
                closeModal={() => { setShowModalConfirm(false) }}
                onConfirm={onDeleteConfirm}
                status={status === ApiStatus.FETCHING}
            />
        )}
    </>)
}